module.exports = __webpack_public_path__ + "startpage-746fed5a/app-store-badge-en-f34e37530055b2c97ba3828e574e85f3.svg";